import React, { useState } from "react";
import { Portal } from "@/lib/api";
import { Send } from "lucide-react";
import { toast } from "sonner";

const PortalContact = () => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!body.trim()) {
      toast.error("Please add a message");
      return;
    }
    setSending(true);
    try {
      await Portal.messages.send({ subject: subject.trim(), body: body.trim() });
      toast.success("Message sent — ATC will respond by email");
      setSubject(""); setBody("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to send");
    } finally { setSending(false); }
  };

  return (
    <section className="p-10 max-w-3xl" data-testid="portal-contact-tab">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.22em] text-atc-blue mb-2">Portal</div>
        <h1 className="font-display font-black text-4xl text-white">Contact ATC</h1>
        <p className="text-slate-400 text-sm mt-2">Send us a direct message. We&apos;ll reply to the email on your account.</p>
      </div>

      <div className="glass rounded-2xl p-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-[0.18em] text-slate-400 mb-1.5 block">Subject (optional)</label>
          <input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="What's this about?"
            className="w-full px-3 py-2 rounded-lg bg-slate-950 border border-white/10 text-sm text-white placeholder:text-slate-500"
            data-testid="portal-message-subject"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.18em] text-slate-400 mb-1.5 block">Message</label>
          <textarea
            rows={7}
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Type your message to ATC…"
            className="w-full px-3 py-2 rounded-lg bg-slate-950 border border-white/10 text-sm text-white placeholder:text-slate-500"
            data-testid="portal-message-body"
          />
        </div>
        <div className="flex justify-end">
          <button
            onClick={submit}
            disabled={sending}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full brand-gradient text-white text-sm font-semibold hover:opacity-95 disabled:opacity-60"
            data-testid="portal-message-send"
          >
            <Send className="h-4 w-4" /> {sending ? "Sending…" : "Send message"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PortalContact;
